module.exports = __webpack_public_path__ + "static/media/AeroFarm.36a5401a.svg";